__webpack_require__.p = "https://static.flicknovelcdn.com/reader-website-static/prod_4830894_83_0bc5d92d/_next/";